// hl-quality — Wallet-Quality-Tag-Logik (V1-Port aus HyperliquidView.js).
//
// Klassifiziert eine Wallet basierend auf Account-Value + Volume + PnL in
// 5 Stufen: LEGIT / OK / SMALL / DUST / GHOST. Wird von DataTable als Badge
// im Quality-Column gerendert + vom Smart-Filter (Leaderboard) verwendet.

export type WalletQuality = 'LEGIT' | 'OK' | 'SMALL' | 'DUST' | 'GHOST';

export interface QualityInputs {
  /** Account-Value in USD. */
  av: number;
  /** Trading-Volume (z.B. 30d) in USD. Default 0. */
  vol?: number;
  /** PnL in USD (positiv = profit, negativ = loss). Default 0. */
  pnl?: number;
}

/**
 * Klassifizierung:
 *   GHOST  — av === 0 (Wallet ist leer, vermutlich aufgegeben)
 *   DUST   — av < $100 (Staub, irrelevant für Trade-Signale)
 *   SMALL  — av < $10K (Kleinanleger, wenig Signal-Wert)
 *   LEGIT  — av >= $100K UND (vol >= $10M ODER pnl >= $100K) — professionell
 *   OK     — alles dazwischen (Mittelgroß, akzeptables Signal)
 */
export function getQuality(input: QualityInputs): WalletQuality {
  const { av, vol = 0, pnl = 0 } = input;
  if (av === 0) return 'GHOST';
  if (av < 100) return 'DUST';
  if (av < 10_000) return 'SMALL';
  if (av >= 100_000 && (vol >= 10_000_000 || pnl >= 100_000)) return 'LEGIT';
  return 'OK';
}

/** CSS-Klasse für den Badge-Style — gepairt mit globals.css `.quality-badge--*`. */
export function qualityClass(quality: WalletQuality): string {
  return `quality-badge quality-badge--${quality.toLowerCase()}`;
}
